import i18next from 'i18next'

i18next.addResourceBundle('en', 'graph', {
    title: 'Table Dependencies',
    scope_module: 'Current module',
    scope_project: 'Whole project',
    empty: 'No table dependencies to display.',
    load_failed: 'Failed to load the table dependency graph.',
    search_placeholder: 'Find a table by name',
    search_matches: '{{count}} tables named "{{name}}"',
    fit: 'Fit to screen',
    zoom_in: 'Zoom in',
    zoom_out: 'Zoom out',
    stats: '{{nodes}} tables · {{edges}} dependencies',
    stats_cyclic: '{{cyclic}} in cycles',
    stats_isolated: '{{isolated}} isolated',
    find_cycles: 'Find call cycles',
    cycles_found: 'Call cycles ({{count}})',
    cycles_none: 'No call cycles found',
    cycles_more: 'Showing the first {{count}}',
    legend: {
        show: 'Legend',
        hint: 'Click a kind to hide it on the graph',
        dispatcher: 'Dispatcher — selects a version',
        isolated: 'Isolated — no links',
        cycle: 'In a cycle or recursive',
        entity: 'Data type: name, then its fields or values',
        extends: 'Extends a data type',
        one: 'Holds one value of that type',
        many: 'Holds many values of that type',
        area: 'Data model of one project',
        weight: 'Thicker border = used more',
    },
    panel: {
        open: 'Open in editor',
        uses: 'Uses',
        dependents: 'Used by',
        extends: 'Extends',
        fields: 'Fields',
        values: 'Values',
        values_summary: '{{count}} values of {{type}}',
        values_truncated: 'Open the table to see all {{count}} values',
        focus: 'Focus',
        focus_uses: 'Uses',
        focus_used_by: 'Used by',
        focus_both: 'Both',
        back: 'Whole project',
        highlight_path: "Show one version's path",
        dispatcher_hint: 'Generated table that selects one version at runtime',
        external: 'Belongs to {{project}}. Open that project to edit this table.',
    },
    meta: {
        identity: 'Identity',
        signature: 'Signature',
        returns: 'Returns',
        file: 'File',
        pos: 'Cells',
        business_dimension: 'Business Dimension',
    },
})
